import { useState } from "react";
import { showPopup } from "./helpers";
import { formatNumberWithCommas, unformatNumber } from "./helpers";
import emailjs from 'emailjs-com';
const regEmail     = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


const EmailSection = ({ 
    formData,
    setFormData,
    resetHandler,
    userParams, 
    setUserParams
}) => {
    const [ isEmail,   setIsEmail ]     = useState(false);
    const [ emailUser, setEmailUser ] = useState('');

    const showEmailField = () => {
        setIsEmail(true);
    };

    const emailChangeHandler = (e) => {
      setEmailUser(e.target.value);
      setUserParams({ ...userParams, email: e.target.value });
    };

    const sendEmailHandler = () => {
      if (emailUser.match(regEmail)) {
        setIsEmail(false);
        showPopup(`Thank you ${emailUser} for your interest. We will get back to you shortly.`); 

        // Send data to email
        emailjs.send(
          'service_faanq32',             // YOUR_SERVICE_ID
          'template_57sg55y',            // YOUR_TEMPLATE_ID
          userParams, 'ivy4pzP8DwZwyM72k') // YOUR_USER_ID
        .then((result) => {
          console.log('Email successfully sent:', result.text);
        }, (error) => {
          console.log('Failed to send email:', error.text);
        });
      } else {
        setEmailUser('');
        showPopup(`Invalid email address!`); 
      }
    }

    return (
        <>
        {isEmail &&
            <div class="mb-3 email-block">
              <label for="email_user" class="form-label">Email Me The Results</label>
              <input type="email" id="email_user" class="form-control form-control-lg" onChange={emailChangeHandler} placeholder="Your email" />
              {emailUser !== '' &&
                <button type="button" class="btn btn-danger btn-lg" id='send-btn' onClick={sendEmailHandler}>Send</button>
              }
              {emailUser === '' &&
                <button type="button" class="btn btn-danger btn-lg" id='send-btn' disabled>Send</button>
              }
            </div>
            }
            <div class="mb-3 buttons-block">
              {!isEmail &&
                <button onClick={showEmailField} type="button" class="btn btn-primary btn-lg" id='email-btn'>Email me results</button>
              }
              <button type="button" class="btn btn-secondary btn-lg" id='reset-btn' onClick={resetHandler}>Reset</button>
            </div>
        </>
    );
}

export default EmailSection;